export default __webpack_public_path__ + "images/IV.c6aebac.png";